module.exports = __webpack_public_path__ + "img/Joimax_Single_Frame0001.2394621f.jpg";